import ArticleSlider from './article-slider';
export default ArticleSlider;
